import './feedbacks.css'
import { Star } from "@mui/icons-material";
import { useGetAllReviewQuery, useDeleteReviewMutation, useModerateReviewMutation } from '../../services/feedbackApi'
import afatar from "../../images/femaleAfatar.png";
import { RateReviewOutlined } from "@mui/icons-material";
import {
  AdminPageHeader,
  AdminTable,
  AdminBadge,
  AdminButton,
  useConfirm,
  useToast,
} from '../../components/ui'
import { formatDate } from '../../utils/format'

// Ratings are 1-5 (validated server-side) - clamp defensively in case any
// stale/seeded data is out of range, rather than rendering a broken star row.
const starsFor = (rating) => Array.from({ length: Math.max(0, Math.min(5, Math.round(rating || 0))) });

function Feedbacks() {
  const response = useGetAllReviewQuery();
  const [deleteReview] = useDeleteReviewMutation();
  const [moderateReview] = useModerateReviewMutation();
  const confirm = useConfirm();
  const toast = useToast();

  const rows = (response.data || []).slice().reverse();

  const handleToggleApproval = (review) => {
    moderateReview({ id: review.id, is_approved: !review.is_approved });
  };

  const handleDelete = async (review) => {
    const ok = await confirm({
      title: "Delete review",
      message: "Permanently delete this review? This can't be undone.",
      confirmLabel: "Delete",
      danger: true,
    });
    if (!ok) return;
    const res = await deleteReview(review.id);
    if (res.error) toast.error("Could not delete this review.");
    else toast.success("Review deleted.");
  };

  const columns = [
    {
      key: "customer",
      header: "Reviewer",
      render: (r) => (
        <div className="feedbackReviewer">
          <img src={afatar} alt="" />
          <span>{r.customer.first_Name} {r.customer.last_Name}</span>
        </div>
      ),
    },
    {
      key: "rating",
      header: "Rating",
      render: (r) => (
        <div className="feedbackStars">
          {starsFor(r.rating).map((_, i) => <Star key={i} />)}
        </div>
      ),
    },
    { key: "content", header: "Review", render: (r) => <span className="feedbackContent">{r.content}</span> },
    { key: "product", header: "Product", render: (r) => r.productReviewed.name },
    { key: "reviewDate", header: "Date", render: (r) => formatDate(r.reviewDate) },
    {
      key: "is_approved",
      header: "Status",
      render: (r) => <AdminBadge variant={r.is_approved ? "success" : "neutral"}>{r.is_approved ? "Visible" : "Hidden"}</AdminBadge>,
    },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (r) => (
        <div className="feedbackActions">
          <AdminButton size="sm" variant="secondary" onClick={() => handleToggleApproval(r)}>
            {r.is_approved ? "Hide" : "Approve"}
          </AdminButton>
          <AdminButton size="sm" variant="danger" onClick={() => handleDelete(r)}>
            Delete
          </AdminButton>
        </div>
      ),
    },
  ];

  return (
    <div>
      <AdminPageHeader
        title="Reviews"
        subtitle="Moderate customer product reviews."
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Reviews" }]}
      />
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(r) => r.id}
        isLoading={response.isLoading}
        emptyIcon={<RateReviewOutlined />}
        emptyTitle={response.isError ? "Couldn't load reviews" : "No reviews yet"}
        emptyDescription={response.isError ? "Something went wrong. Try refreshing the page." : undefined}
        pageSize={10}
      />
    </div>
  );
}

export default Feedbacks
